import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function PlayWorkflowIcon({
  className,
  dataCy,
  height,
  stroke = IconColors.DarkGrey,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      dataCy={dataCy}
      fill="none"
      height={height ?? 20}
      viewBoxDimensions="0 0 20 20"
      width={width ?? 20}
    >
      <path
        d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="m8.2 6.4 5.4 3.6-5.4 3.6V6.4z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SimpleIcon>
  );
}
